<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M7 3H5V11H7V3ZM19 3H17V15H19V3ZM3 13H5V21H7V13H9V11H3V13ZM15 7H13V3H11V7H9V9H15V7ZM11 21H13V9H11V21ZM15 15V17H17V21H19V17H21V15H15Z"
      fill="currentColor"
    />
  </svg>
</template>
